export const GET_PATIENT_APPOINTMENT_LIST = "GET_PATIENT_APPOINTMENT_LIST"
export const GET_PATIENT_APPOINTMENT_LIST_FAIL = "GET_PATIENT_APPOINTMENT_LIST_FAIL"
export const GET_PATIENT_APPOINTMENT_LIST_SUCCESS = "GET_PATIENT_APPOINTMENT_LIST_SUCCESS"
export const GET_PATIENT_APPOINTMENT_LIST_RESET = "GET_PATIENT_APPOINTMENT_LIST_RESET"

export const getPatientAppointmentList = (params) => {
    console.log("acion parms", params);
    return { type: GET_PATIENT_APPOINTMENT_LIST, params }
}

export const getPatientAppointmentListSuccess = (response) => {
    return { type: GET_PATIENT_APPOINTMENT_LIST_SUCCESS, response }
}

export const getPatientAppointmentListFail = (response) => {
    return { type: GET_PATIENT_APPOINTMENT_LIST_FAIL, response }
}

export const getPatientAppointmentListResetState = () => {
    return { type: GET_PATIENT_APPOINTMENT_LIST_RESET }
}